import { render, staticRenderFns } from "./inline.vue?vue&type=template&id=2c083b1f&scoped=true"
import script from "./inline.vue?vue&type=script&lang=js"
export * from "./inline.vue?vue&type=script&lang=js"
import style0 from "./inline.vue?vue&type=style&index=0&lang=scss"
import style1 from "./inline.vue?vue&type=style&index=1&id=2c083b1f&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c083b1f",
  null
  
)

export default component.exports